/*
 *
 * This component is useful to highlight parts of a text surrounding it with a <b> element.
 *
 * Example of Usage:
 *
 * 1 - Simple usage
 *    <BoldText text="This text should be bold **here**"/>
 *
 * 2 - Custom bold strength
 *    <BoldText text="Here is normal and **here is heavy**. Here is normal again"
 *      fontWeight="heavy"/>
 *
 */

"use strict";

var BoldText = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired,
    fontWeight: React.PropTypes.oneOf(["normal", "soft", "bold", "heavy"]),
    className: React.PropTypes.string
  },
  getDefaultProps: function() {
    return {
      fontWeight: "bold"
    };
  },
  applyBold: function() {
    var boldElem = this.getBoldElem(this.props.fontWeight);
    return this.replaceText(this.props.text, boldElem);
  },
  getBoldElem: function(fontWeight) {
    var weightClasses = {
      normal: "fw-400",
      soft: "fw-500",
      bold: "fw-700",
      heavy: "fw-900"
    };
    return {
      begin: "<b class='" + weightClasses[fontWeight] + "'>",
      end: "</b>"
    };
  },
  replaceText: function(text, boldElem) {
    var regex = new RegExp(/\*\*(.+?)\*\*/g);
    return text.replace(regex, boldElem.begin + "$1" + boldElem.end);
  },
  render: function() {
    var textWithBold = this.applyBold(this.props.text);
    return (
     <span className={this.props.className} dangerouslySetInnerHTML={{__html: textWithBold}}/>
    );
  }
});

module.exports = BoldText;



// WEBPACK FOOTER //
// ./app/shared/components/BoldText/bold-text.jsx